import jQuery from "jquery";

jQuery(function($){

    let $feeBack ='.show-process-feedback';


    $('.btn.btn-get-data-bundle').on('click', function(e){
        let $this = $(this);
        
        if($this.hasClass('data-error')){
            swal("Oups !", "Votre numéro ne vous permet pas d’acheter ce forfait", "error",{button: "Fermer"});
        }else{
            swal("Youpii !", "Lorem ipsum dolor sit amet consectetur, adipisicing elit.", "success",{button: "Fermer"});
        }

        finalFeedBack( !$this.hasClass('data-error'))
    });


    function finalFeedBack( success){
        $($feeBack).addClass('d-none');
        if( success === false) {
            $($feeBack+'-error').removeClass('d-none');
        }else{
            $($feeBack+'-success').removeClass('d-none');
        }
    }

    let defaultLabel = '.data-bundle-wrap-';

    $('.btn.show-more-btn').on('click', function(e){
        e.preventDefault();
        let $tempLabel = $(this).text();
        let $section = $(this).data('filter');
        $(this).text($(this).data('next-label'));
        $(this).data('next-label', $tempLabel);
        $(defaultLabel + $section).toggleClass('d-none');
    });


    
    $('#ExpressDataBundle').on('submit', function (e) {
        e.preventDefault();
        var form = this;

        var elmErr = $(form).find('.form-control:invalid,.custom-select:invalid,.custom-range:invalid,.custom-file-input:invalid,.custom-control-input:invalid');
        $(form).addClass('was-validated');

        if (!form.checkValidity()) {
        e.preventDefault()
        e.stopPropagation()
      }

        if (elmErr && elmErr.length > 0) {
            var $this = $(elmErr)[0];
            $this.focus();
            // Form validation failed
            return false;
        }
    })    
}(jQuery ))